export const POST_CALCULATE_VACACIONES = "POST_CALCULATE_VACACIONES";
export const POST_CALCULATE_VACACIONES_SUCCESS = "POST_CALCULATE_VACACIONES_SUCCESS";

export default {
  POST_CALCULATE_VACACIONES,
  POST_CALCULATE_VACACIONES_SUCCESS,
};
